import { Grid, Box, Stack } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ControlledTextInput, WsButton } from 'wisestep-base';

import FAQDetailsDetailsCommonFields from '../FAQDetailsCommonFields';
import FAQDetailsPage from '../FAQDetailsPage';

const TeamOwners = () => {
  const methods = useForm();

  const teamOwners = [
    {
      title: 'Q: What is a Team Owner and how does it help ?',
      text: 'A: Wisestep helps make recruiting more efficient for businesses. Businesses work in teams and Business owners can create teams on Wisestep to effectively replicate their organization on the Wisestep platform.',
    },
    {
      title: 'Q: Who should be interested in becoming a Team Owner ?',
      text: 'A: You should be looking at teams if you are any of the following Promoter, Business owner or CEO of a Recruitment Agency CHRO, Head of Human Resources, Head of Talent Acquisition for a Business CEO, Senior Business Leader in a business that is trying to scale their Hiring',
    },
    {
      title: 'Q: I am not able to create teams. What should I do ?',
      text: 'A: Team Creation privileges are not enabled by default. If you need to create teams  write to us at support@wisestepmail.com for more details',
    },
    {
      title: 'Q: How Many teams can I Create ?',
      text: 'A: If you have privileges to create a team, you can see then number of Teams and the maximum number of Team members that can be added under the“ My Teams” Link visible under the Teams Tab on the Menu',
    },
    {
      title: 'Q: How do I create my own workflow on Wisestep ?"',
      text: 'A: You can do this quite easily on the platform and get set up in minutes. However, to  get the right structure and flow in place, we would suggest you write to support @wisestepmail.com for a quick consultation',
    },
    {
      title: 'Q: How do I remove employees who have left our organization ?',
      text: 'A: Under the “Teams Created by Me” Section click on the person icon in front of a team to see the privileges to add or remove a team member.',
    },
    {
      title: 'Q: How do I disable emails for people who have left the company ?',
      text: 'A: Just remove them from all the teams they were part of.',
    },
    {
      title: 'Q: How do I deactivate accounts of people who have left the company ?',
      text: 'A: Under app settings page look for User Management Page, select the button to Edit user Privileges and Uncheck the Activation check box to deactivate the user.',
    },

    {
      title: 'Q: What is Data Sharing ?',
      text: 'A: Data sharing allows you to share Candidate data among teams within the same Team Owner. You can share the Candidate Mappings and the Search Candidates data among team for better collaboration between Teams. This option is available in App settings page.',
    },
    {
      title:
        'Q: When a team member is removed from a team, what happens to the data of the team member ?',
      text: 'A: If a team member is removed from a team, their data continues to remain with the team and is not deleted.',
    },
  ];

  const [teamOwnersList, setTeamOwnersList] = useState<
    { title: string; text: string }[] | undefined
  >(teamOwners);

  const [textValue, setTextValue] = useState('');

  const handleOnClick = () => {
    const findText =
      teamOwners && teamOwners?.length > 0
        ? teamOwners?.filter((b) => b?.title.toUpperCase().includes(textValue.toUpperCase()))
        : undefined;
    setTeamOwnersList(findText);
  };
  return (
    <FAQDetailsPage>
      <Box pt={2}>
        <FormProvider {...methods}>
          <Grid item xs={12} pb={2} bgcolor="white" p={2}>
            <Stack direction="row" spacing={1}>
              <ControlledTextInput
                placeholder="Search..."
                name="search"
                type="text"
                fullWidth
                required
                autoComplete="text"
                value={textValue}
                onChange={(e) => setTextValue(e.target.value)}
              />
              <WsButton disabled={!textValue} size="large" onClick={handleOnClick}>
                Search
              </WsButton>
            </Stack>
          </Grid>
          <Grid container spacing={2} pt={2}>
            {teamOwnersList &&
              teamOwnersList?.length > 0 &&
              teamOwnersList?.map((list, index) => (
                <Grid item xs={12} key={index}>
                  <FAQDetailsDetailsCommonFields title={list.title} text={list.text} />
                </Grid>
              ))}
          </Grid>
        </FormProvider>
      </Box>
    </FAQDetailsPage>
  );
};

export default TeamOwners;
